import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { ViewCell } from '../ofbiz-form-model';
import { Cell } from 'angular2-smart-table';

@Component({
  template: `
    <div class="hyperlink" (click)="emit($event)">
      <span>
        <img src="assets/images/icons/outline/folder-outline.svg" class="custom-icon hungry">
      </span>
      {{renderValue}}
    </div>
  `,
  styleUrls: ['./ofbiz-cell-linked-list.component.scss'],
})
export class OfbizCellLinkedListComponent implements OnInit {
  renderValue: string;
  cell: Cell;
  @Input() value: string | number;
  rowData: any;
  @Input() field: any;
  @Input() remoteFormData: any;
  selectedValue: any;
  @Output() cellHyperlinkSelected = new EventEmitter();

  constructor() {
    console.log("OfbizCellLinkedListComponent constructor called");
    // console.log({TrackRenderComponent:{Component:"OfbizCellLinkedListComponent",RowData:this.rowData}});
  }

  ngOnInit(): void {
    this.rowData = this.cell?.getRow().getData();
    this.value = this.cell?.getValue();
    console.log(this.field, this.rowData);
    console.log(this.rowData);
    this.renderValue = this.value?.toString();
    console.log(this.renderValue);
    console.log(this.remoteFormData);
    console.log(this.field)
    if (this.field) {
      this.makeSelectedValue();
      console.log(this.selectedValue);
    }
    OfbizCellLinkedListComponent.componentInit(this, this.cell, this.field);

  }

  static componentInit(instance: OfbizCellLinkedListComponent, cell: Cell, field: any) {
    // instance.renderValue = cell.getValue().toUpperCase();
    console.log(cell);
    console.log('componentInit called', instance, cell);
    // instance.field = cell.getColumn().field;
    instance.cell = cell;
  }

  makeSelectedValue() {
    console.log(this.field);
    return this.selectedValue = {
      event: this.field.event, // Event can be view,list,add or edit
      type: this.field.formData.formName, // Type is formName/ListName/View
      label: "", // Text value to be used in headers/breadCrumbs etc.
      data: {
        formData: {
          formName: this.field.formData.formName,
          formLocation: this.field.formData.formLocation,
          listType: this.field.formData.listType,
          link: this.formatLink(this.field.formData.link, this.makeParameterMap(this.rowData, this.field)),
          entityName: "",
          viewIndex: 1
        },
        endPoint: "string",
        appContext: "",
        parameters: {}
      }
    }
  }
  emit(e) {
    console.log("HyperLink clicked in list link cell -  this is the rowData", this.rowData)

    this.cellHyperlinkSelected.emit(this.selectedValue);
  }

  formatLink(rawLink: string, parameterMaps: any): string {
    let link = "";
    if (this.containsDollarBracketVariable(rawLink)) {
      link = this.replaceDollarBracketVariable(rawLink, parameterMaps);
    }
    return link
  }

  makeParameterMap(rowData, field) {
    let parameters = {};
    if (rowData["parameterMaps"] != undefined && rowData["parameterMaps"].length > 0) {
      const parameterMaps: any[] = rowData["parameterMaps"];
      let parameterMap = parameterMaps.find(element => element.fieldName == field.name);
      if (parameterMap != undefined) {
        // console.log({parameterMapFromRowData:parameterMap});
        parameters = parameterMap["parameterMap"];
      } else {
        parameterMap = parameterMaps[0];
        parameters = parameterMap["parameterMap"];
      }
    }
    if (field.parameterList != undefined && field.parameterList.length > 0) {
      field.parameterList.forEach(parameter => {
        if (!parameters.hasOwnProperty(parameter["name"])) {
          if (this.rowData[parameter["name"]] != undefined) {
            parameters[parameter["name"]] = this.rowData[parameter["name"]];
          }
        }
      });
      console.log({ parameterListFromField: field.parameterList }, parameters);
    }
    return parameters
  }

  containsDollarBracketVariable(str: string): boolean {
    const regex = /\${(.*?)}/;
    return regex.test(str);
  }

  replaceDollarBracketVariable(str: string, variables: { [key: string]: string }): string {
    return str.replace(/\${(.*?)}/g, (match, p1) => {
      return variables[p1] || '';
    });
  }

}


